<template>
  <div class="slide-input-row">
    <div class="slide-row">
      <div class="slide-col-left">
        <label>{{label}}</label>
      </div>
      <div class="slide-col-right">
        <input type="hidden" v-model="value" />
        <input
          type="tel"
          :maxlength="10"
          v-model="displayValue"
          @blur="blurInput"
          v-on:keypress="checkNumber(event)"
        />
        <span>฿</span>
      </div>
    </div>
    <vue-slider v-model="valueSlide" @change="changeVal()" v-bind="options" />
  </div>
</template>
<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
export default {
  components: {
    VueSlider
  },
  watch: {
    value: function(v) {
      this.$emit("input-range", parseInt(v), this.name);
      this.displayValue = this.parseNumberFormat(v);
    },
    displayValue: function(v) {
      let num = parseFloat(v.replace(/,/g, ""));
      this.$emit("input-range", num, this.name);
      this.displayValue = this.parseNumberFormat(num);
      if (num >= this.max) {
        this.valueSlide = this.max;
      } else {
        this.valueSlide = num;
      }
    }
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    interval: {
      type: Number,
      default: 0
    },
    default: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      value: this.default,
      valueSlide: this.default,
      displayValue: this.parseNumberFormat(this.default),
      options: {
        dotSize: 24,
        width: "auto",
        height: 13,
        direction: "ltr",
        data: null,
        min: this.min,
        max: this.max,
        interval: this.interval,
        disabled: false,
        clickable: true,
        duration: 0.5,
        lazy: false,
        tooltip: "none",
        tooltipPlacement: "top",
        tooltipFormatter: void 0,
        useKeyboard: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: false,
        dotOptions: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0
      }
    };
  },
  methods: {
    checkNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    changeVal() {
      this.value = this.valueSlide;
    },
    blurInput() {
      let num = parseFloat(this.displayValue.replace(/,/g, ""));
      if (num < this.min) {
        this.displayValue = this.min;
      }
      this.displayValue = this.parseNumberFormat(this.displayValue);
    },
    parseNumberFormat(num) {
      if (num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
  }
};
</script>
<style lang="scss">
.slide-input-row {
  .slide-row {
    display: flex;
    padding-bottom: 10px;
    align-items: center;
    justify-content: center;
    .slide-col-left {
      width: 55%;
      text-align: left;
      label {
        font-size: 16px;
        font-weight: bold;
      }
    }
    .slide-col-right {
      width: 45%;
      text-align: right;
      position: relative;
      input {
        width: 100%;
        border: solid 1px $color-border;
        padding: 11px 20px 11px 0;
        text-align: center;
        border-radius: 4px;
        font-size: 16px;
        font-weight: bold;
        color: #444444;
        outline: none;
      }
      span {
        position: absolute;
        top: 6px;
        right: 15px;
        font-size: 16px;
        font-weight: normal;
        color: $color-secondary;
      }
    }
  }
  .vue-slider-rail {
    background-color: #e6e6e6;
    border-radius: 15px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.02);
  }
  .vue-slider-process {
    background-color: $color-primary-finno;
    border-radius: 15px;
  }
  .vue-slider-dot-handle {
    -webkit-box-shadow: 0 1px 6px 0 rgba(153, 153, 153, 0.57);
    box-shadow: 0 1px 6px 0 rgba(153, 153, 153, 0.57);
  }
  .vue-slider-dot-handle-focus {
    -webkit-box-shadow: 0 1px 6px 0 rgba(153, 153, 153, 0.57);
    box-shadow: 0 1px 6px 0 rgba(153, 153, 153, 0.57);
  }
}
</style>

